import { TKV2_ORDER_API } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  CreateTkv2OrderAPIError,
  CreateTkv2OrderAPIVariables,
  fetchCreateTkv2OrderAPI,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_API.POST;

export const useCreateTkv2OrderAPI = (
  options?: Omit<
    UseMutationOptions<
      z.infer<typeof API_SCHEMA.RESPONSE>,
      CreateTkv2OrderAPIError,
      CreateTkv2OrderAPIVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<
    z.infer<typeof API_SCHEMA.RESPONSE>,
    CreateTkv2OrderAPIError,
    CreateTkv2OrderAPIVariables
  >({
    mutationFn: (variables: CreateTkv2OrderAPIVariables) =>
      fetchCreateTkv2OrderAPI({
        ...fetcherOptions,
        ...variables,
        body: API_SCHEMA.REQUEST.BODY.parse(variables.body),
      }).then((r) => API_SCHEMA.RESPONSE.parse(r)),
    ...options,
  });
};
